// extracted by mini-css-extract-plugin
export default {"wrapper":"yon_wrapper__cA+gI","text":"yon_text__TtqMc","btn":"yon_btn__2mvJL","blue":"yon_blue__aEC+a","red":"yon_red__bJup5","redpre":"yon_redpre__o4Iy9"};